/**
 * Phase 15.6P — Public URL helper.
 *
 * Produces a canonical PRODUCTION URL for share cards, social embeds, and
 * deep links — even when the user is running the app on the preview / dev
 * environment. This stops share cards from broadcasting `preview.emergentagent.com`
 * URLs that production users can't reach.
 *
 * Precedence:
 *   1. process.env.REACT_APP_PUBLIC_URL  (deployment-configurable)
 *   2. https://rgmstudio.org             (canonical production hostname)
 */
const FALLBACK_PUBLIC_URL = "https://rgmstudio.org";

export const getPublicAppUrl = () => {
  const envUrl = (process.env.REACT_APP_PUBLIC_URL || "").trim();
  if (envUrl && /^https?:\/\//i.test(envUrl)) {
    return envUrl.replace(/\/+$/, "");
  }
  return FALLBACK_PUBLIC_URL;
};

export const getPublicShareUrl = (path = "/") => {
  const base = getPublicAppUrl();
  if (!path) return base;
  return path.startsWith("/") ? `${base}${path}` : `${base}/${path}`;
};

export default getPublicShareUrl;
